import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const circleCreationSchema = z.object({
  source: z.string().optional(),
});

export const Route = createFileRoute("/$lang/circle-creation")({
  component: React.lazy(() =>
    import("@/pages/circles/CircleCreation").then((mod) => ({
      default: mod.default,
    })),
  ),
  validateSearch: (search) => circleCreationSchema.parse(search),
});
